"use client";

import React, { JSX, useMemo } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import Pager from "./Pager";
/*import "./Pagination.scss";*/

const VALUES = [
  <i key="arrow-first" className="fa fa-arrow-left" />,
  <i key="arrow-prev" className="fa fa-chevron-left" />,
  "",
  <i key="arrow-next" className="fa fa-chevron-right" />,
  <i key="arrow-last" className="fa fa-arrow-right" />,
];

function generatePagers(
  current: number,
  max: number,
  buildHref: (page: number) => string,
) {
  const pages = [-current, -1, 0, 1, max - current].map((v) =>
    Math.max(1, Math.min(max, v + current)),
  );

  const pagers: JSX.Element[] = [];

  pages.forEach((v, i) => {
    const value = i === 2 ? v.toString() : VALUES[i];

    pagers.push(
      <Pager
        key={i}
        to={buildHref(v)}
        value={i === 2 ? `${value} / ${max}` : value}
        active={i === 2}
      />,
    );
  });

  return pagers;
}

const Pagination = ({
  currentPage,
  totalPages,
  basePath,
}: {
  currentPage: number;
  totalPages: number;
  basePath?: string;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const searchString = useMemo(() => searchParams.toString(), [searchParams]);

  const buildHref = (page: number) => {
    if (basePath) {
      return page === 1 ? basePath : `${basePath}/${page}`;
    }

    const params = new URLSearchParams(searchString);
    params.set("page", page.toString());
    const query = params.toString();
    return query ? `${pathname}?${query}` : pathname;
  };

  const pagers = generatePagers(currentPage, totalPages, buildHref);

  if (totalPages < 2) {
    return <></>;
  }

  return (
    <div className="row mt-4">
      <div className="col-12">
        <nav aria-label="Blog pagination" className="Pagination">
          <ul className="pagination pagination-lg justify-content-center">
            {pagers}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Pagination;
